import axios from "axios";
import Qs from "qs";
//顶部页面加载条
import NProgress from "nprogress";
import "nprogress/nprogress.css";

import router from "../router/router";
//let base = "http://127.0.0.1:9090",
//let base = "/sbgl",  //测试
export let base = "/sbgl_api", //正式
  baseURL = ""; //测试版api+本地调试

axios.defaults.withCredentials = true;
axios.defaults.baseURL = baseURL;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.headers.post["withCredentials"] = true;
axios.defaults.headers.post["crossDomain"] = true;
axios.defaults.headers.post["Access-Control-Allow-Origin"] = true;

NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.3,
});
// 请求拦截器
axios.interceptors.request.use((config) => {
  NProgress.start();
  return config;
});
// 登录过期处理：清除本地存储并跳转登录页
var _isRedirecting = false;
// 记录用户离开登录页的时间，用于区分"刚登录 session 未同步"和"真正的登录过期"
var _loginTime = 0;
function handleLoginExpired() {
  if (_isRedirecting) return;
  // 已经在登录页则不再跳转
  if (router.currentRoute && router.currentRoute.path === '/login') return;
  // 如果 401 发生在离开登录页后 10 秒内，认为是刚登录成功但后端 session 未就绪，
  // 此时不执行过期处理，由调用方自行重试
  if (_loginTime > 0 && (Date.now() - _loginTime) < 10000) return;
  _isRedirecting = true;
  _loginTime = 0;
  localStorage.removeItem('token');
  localStorage.removeItem('theme');
  localStorage.removeItem('header');
  localStorage.removeItem('user');
  sessionStorage.clear();
  router.replace("/login");
}
// 供 router.beforeEach 调用：用户登录后离开登录页时重置标志并记录时间
export function resetLoginRedirect() {
  _isRedirecting = false;
  _loginTime = Date.now();
}

axios.interceptors.response.use(
  (res) => {
    NProgress.done();
    // 后端返回 HTTP 200 但 body 中 code=401 表示登录过期
    if (res.data && (res.data.code === 401 || res.data.code === 403)) {
      handleLoginExpired();
      // 如果 handleLoginExpired 因登录时间窗口而未触发，说明是 session 未就绪，
      // 返回 reject 让调用方的 catch 处理并重试
      if (_loginTime > 0 && (Date.now() - _loginTime) < 10000) {
        return Promise.reject(new Error('SESSION_NOT_READY'));
      }
      // 已执行过期处理，不再把错误传播给调用方
      return new Promise(() => {});
    }
    return res;
  },
  (error) => {
    NProgress.done();
    if (error.response) {
      var status = error.response.status;
      // 处理 HTTP 401 未授权 / 403 禁止访问
      if (status === 401 || status === 403) {
        handleLoginExpired();
        return new Promise(() => {});
      }
      // 兼容后端自定义响应头判断
      var str = error.response.headers["userstatue"];
      if (str == "delFlag") {
        handleLoginExpired();
        return new Promise(() => {});
      }
      return error.response;
    }
    return Promise.reject(error);
  }
);

export const dl = (params) => {
  return axios
    .get(`${base}/uplade/upl`, {
      params: {
        userName: params.userName,
        password: params.password,
        code: params.code,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
  // return axios.get(`${base}/user/login`,Qs.stringify(params)).then(res => res.data).catch(error => error);
};
// 修改皮肤
export const updateSkin = (params) => {
  return axios
    .post(`${base}/user/updateSkin`, params)
    .then((res) => res.data)
    .catch((error) => error);
};

// 获取图片验证码
export const getCodes = (params) => {
  return "" + base + "/user/code?_t=" + Date.now() + "_" + Math.random().toString(36).slice(2);
};

// 获取域名
export const getBase = (params) => {
  return base;
};

// 获取手机验证码（忘记密码用）
export const getSms = (params) => {
  return axios
    .get(`${base}/user/SendSms`, {
      params: { userId: params.userId, verifyCode: params.verifyCode },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// 发送短信登录验证码
export const sendLoginSms = (params) => {
  return axios
    .post(`${base}/user/sendLoginSms`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 短信验证码登录
export const loginBySms = (params) => {
  return axios
    .post(`${base}/user/loginBySms`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 强制修改初始密码
export const forceChangePwd = (params) => {
  return axios
    .post(`${base}/user/forceChangePwd`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 管理员解锁用户
export const unlockUser = (params) => {
  return axios
    .post(`${base}/user/unlockUser`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据账号查找手机号（脱敏）
export const lookupPhone = (params) => {
  return axios
    .get(`${base}/user/lookupPhone`, {
      params: { userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// 验证短信验证码
export const verifySmsCode = (params) => {
  return axios
    .post(`${base}/user/verifySmsCode`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 短信验证后重置密码并登录
export const resetPwdAndLogin = (params) => {
  return axios
    .post(`${base}/user/resetPwdAndLogin`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 短信验证修改密码（旧接口，保留兼容）
export const updatePwdBySms = (params) => {
  return axios
    .post(`${base}/user/updatePwdBySms`, params)
    .then((res) => res.data)
    .catch((error) => error);
};
// doc转docx
export const docToDocx = (params) => {
  return axios
    .post(`${base}/upload/docToDocx`, params, {
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// 钉钉获取access_token
export const getAccessToken = (params) => {
  return axios
    .get(`https://oapi.dingtalk.com/gettoken`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 钉钉获取免登code
export const getAuthCode = (params) => {
  return axios
    .get(
      `https://oapi.dingtalk.com/topapi/v2/user/getuserinfo`,
      Qs.stringify(params)
    )
    .then((res) => res.data)
    .catch((error) => error);
};
// 钉钉登录
export const dingdingLogin = (params) => {
  return axios
    .post(`${base}/dingding/dingdingLogin`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 获取钉钉应用配置（AppId、回调地址）
export const getDingTalkConfig = () => {
  return axios
    .get(`${base}/dingding/getDingTalkConfig`)
    .then((res) => res.data)
    .catch((error) => error);
};
// 绑定钉钉账号到系统用户
export const bindDingTalk = (params) => {
  return axios
    .post(`${base}/dingding/bindDingTalk`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//登录
export const login = (params) => {
  return axios
    .get(`${base}/user/login`, {
      params: {
        userName: params.userName,
        password: params.password,
        code: params.code,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
  // return axios.get(`${base}/user/login`,Qs.stringify(params)).then(res => res.data).catch(error => error);
};
//退出登录
export const logout = (params) => {
  return axios
    .post(`${base}/user/loginout`)
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据原始密码修改密码
export const updatePwdByOldPwd = (params) => {
  return axios
    .post(`${base}/user/updatePwdByOldPwd`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//查询所有设备台账
export const selectAllDeviceinfo = (params) => {
  return axios
    .post(`${base}/deviceinfo/selectAllDeviceinfo`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//设备检索
export const searchAllDeviceinfo = (params) => {
  return axios
    .post(`${base}/deviceinfo/searchAllDeviceinfo`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//导出设备台账
export const exportDevice = (params) => {
  return axios
    .post(`${base}/deviceinfo/exportDevice`, Qs.stringify(params), {
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//导出资产卡片
export const exportAssetCard = (params) => {
  return axios
    .post(`${base}/deviceinfo/exportAssetCard`, Qs.stringify(params), {
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//查找台账lable
export const selectAllLable = (params) => {
  return axios
    .get(`${base}/deviceinfoLable/selectAllLable`)
    .then((res) => res.data)
    .catch((error) => error);
};
//查找所有lable
export const findAllModule = (params) => {
  return axios
    .get(`${base}/deviceinfoLable/findAllModule`, {
      params: {
        value: params.value,
        module: params.module,
        content: params.content,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找所有lable
export const selectData = (params) => {
  return axios
    .get(`${base}/deviceinfoLable/selectData`)
    .then((res) => res.data)
    .catch((error) => error);
};
//修改lable
export const updateModule = (params) => {
  return axios
    .post(`${base}/deviceinfoLable/updateModule`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//查询设备详情
export const selectDeviceinfoByid = (params) => {
  return axios
    .get(`${base}/deviceinfo/selectDeviceinfoByid`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询待审核设备的编辑差异（审核对照：旧值→新值）
export const selectEditDiff = (params) => {
  return axios
    .get(`${base}/deviceinfo/selectEditDiff`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//批量查询待审核设备的编辑差异（审核意见弹窗用）
export const selectEditDiffBatch = (ids) => {
  return axios
    .get(`${base}/deviceinfo/selectEditDiffBatch`, { params: { ids: ids } })
    .then((res) => res.data)
    .catch((error) => error);
};


//查询台账对应状态
export const getStatueByDevice = (params) => {
  return axios
    .get(`${base}/deviceinfo/getStatueByDevice`)
    .then((res) => res.data)
    .catch((error) => error);
};
//查询模块对应状态
export const findByModule = (params) => {
  return axios
    .get(`${base}/deviceinfoLable/findByModule`, { params: { module: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询可用设备详情
export const selectAvailableDevice = (params) => {
  return axios
    .get(`${base}/deviceinfo/selectAvailableDevice`, {
      params: {
        companyCode: params.companyCode,
        state: params.state,
        content: params.content,
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
        userId: params.userId,
        isMarket: params.isMarket,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询可调拨设备
export const selectTransferableDevice = (params) => {
  return axios
    .get(`${base}/deviceinfo/selectTransferableDevice`, {
      params: {
        companyCode: params.companyCode,
        state: params.state,
        content: params.content,
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
        userID: params.userId,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询可调拨设备
export const selectTaskDevice = (params) => {
  return axios
    .get(`${base}/deviceinfo/selectTaskDevice`, {
      params: {
        companyCode: params.companyCode,
        state: params.state,
        content: params.content,
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
        userId: params.userId,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// 查询设备台账设备类型
export const getTreeDeviceType = (params) => {
  return axios
    .post(`${base}/deviceType/getTreeDeviceType`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据级别查询设备类型
export const selectDeviceFenlei = (params) => {
  return axios
    .get(`${base}/deviceType/selectDeviceFenlei`, {
      params: { level: params.level, pid: params.pid },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//删除设备
export const deleteDeviceinfoByid = (params) => {
  return axios
    .get(`${base}/deviceinfo/deleteDeviceinfoByid`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//撤回设备
export const withdrawDevice = (params) => {
  return axios
    .post(`${base}/deviceinfo/withdrawDevice`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};

//获取分享字符串
export const getShareString = (params) => {
  return axios
    .post(`${base}/deviceinfo/getShareString`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};

//查找状态
export const selectAllstatus = (params) => {
  return axios
    .get(`${base}/status/selectAllstatus`)
    .then((res) => res.data)
    .catch((error) => error);
};
//查找专业
export const selectAllMajorType = (params) => {
  return axios
    .get(`${base}/majorType/selectAllMajorType`)
    .then((res) => res.data)
    .catch((error) => error);
};
//查找单位
export const selectAllCompany = (params) => {
  return axios
    .get(`${base}/company/selectAllCompany`)
    .then((res) => res.data)
    .catch((error) => error);
};
//查找单位
export const findByCode = (params) => {
  return axios
    .get(`${base}/company/findByCode`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据用户所属单位查找单位
export const treeCompanyByCode = (params) => {
  return axios
    .post(`${base}/company/treeCompanyByCode`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据用户所属单位查找子单位树结构
export const findByUserIdCompanyTree = (params) => {
  return axios
    .get(`${base}/company/findByUserIdCompanyTree`, {
      params: { companyCode: params },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找设备分类
export const selectAllDeviceType = (params) => {
  return axios
    .get(`${base}/deviceType/selectAllDeviceType`)
    .then((res) => res.data)
    .catch((error) => error);
};

//根据pid查找设备分类
export const selectAllDeviceTypeBypid = (params) => {
  return axios
    .get(`${base}/deviceType/selectAllDeviceTypeBypid`, {
      params: { pid: params },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据pid查找设备分类
export const findByIdTypeName = (params) => {
  return axios
    .get(`${base}/deviceType/findByIdTypeName`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
// 查找所有办公设备的子类
export const getDeviceType = (params) => {
  return axios
    .post(`${base}/deviceType/getDeviceType`)
    .then((res) => res.data)
    .catch((error) => error);
};
//根据专业查找项目分类-mid为name
export const selectAllProjectTypeByMid = (params) => {
  return axios
    .get(`${base}/projectType/selectAllProjectTypeByMid`, {
      params: { mid: params },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据专业查找项目分类-mid为id
export const selectAllProjectTypeByMids = (params) => {
  return axios
    .get(`${base}/projectType/selectAllProjectTypeByMids`, {
      params: { mid: params },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// 查找所有项目分类
export const selectAllProjectType = (params) => {
  return axios
    .get(`${base}/projectType/selectAllProjectType`)
    .then((res) => res.data)
    .catch((error) => error);
};
// 管理编号审核
export const selectByGlbh = (params) => {
  return axios
    .get(`${base}/deviceinfo/selectByGlbh`, { params: { glbh: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
// 资产编号审核
export const selectByZcbh = (params) => {
  return axios
    .get(`${base}/deviceinfo/selectByZcbh`, { params: { zcbh: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
// 管理编号自增加
export const GLAdd = (params) => {
  return axios
    .post(`${base}/deviceinfo/GLAdd`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//设备录入
export const insertDeviceinfo = (params) => {
  return axios
    .post(`${base}/deviceinfo/insertDeviceinfo`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};

// 批量录入台账
export const insertDevices = (params) => {
  return axios
    .post(`${base}/deviceinfo/insertDevices`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};

// 批量录入设备超市
export const mktInsertDevices = (params) => {
  return axios
    .post(`${base}/market/insertDevices`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 查找附件
export const selectAnnex = (params) => {
  return axios
    .post(`${base}/deviceAnnex/selectAnnex`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据id查找附件
export const selectAnnexByid = (params) => {
  return axios
    .post(`${base}/deviceAnnex/selectAnnexByid`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 删除附件
export const deleteAnnex = (params) => {
  return axios
    .post(`${base}/deviceAnnex/deleteAnnex`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 修改设备附件
export const updateAnnex = (params) => {
  return axios
    .post(`${base}/deviceAnnex/updateAnnex`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 添加设备附件
export const insertAnnex = (params) => {
  return axios
    .post(`${base}/deviceAnnex/insertAnnex`, params)
    .then((res) => res.data)
    .catch((error) => error);
};
// 批量录入附件
export const insertAnnexsExcel = (params) => {
  return axios
    .post(`${base}/deviceAnnex/insertAnnexsExcel`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 批量添加设备附件
export const insertAnnexs = (params) => {
  return axios
    .post(`${base}/deviceAnnex/insertAnnexs`, JSON.stringify(params), {
      headers: { "Content-Type": "application/json;charsetset=UTF-8" },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//修改设备
export const updateDeviceinfoByid = (params) => {
  return axios
    .post(`${base}/deviceinfo/updateDeviceinfoByid`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 重新提交设备
export const reComitDeviceinfoByid = (params) => {
  return axios
    .post(`${base}/deviceinfo/reComitDeviceinfoByid`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//设备启用停用
export const startOrStop = (params) => {
  return axios
    .post(`${base}/deviceinfo/startOrStop`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 设备设置在用和可调拨
export const usedOrDiaoBo = (params) => {
  return axios
    .post(`${base}/deviceinfo/usedOrDiaoBo`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 上传设备资料
export const uploadAttachments = (params) => {
  return axios
    .post(`${base}/deviceinfo/uploadAttachments`, params, {
      "Content-Type": "multipart/form-data;charset=utf-8",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据试验室查找设备
export const getDeviceByCompany = (params) => {
  return axios
    .post(`${base}/deviceinfo/getDeviceByCompany`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 删除设备资料
export const deleteById = (params) => {
  return axios
    .get(`${base}/deviceDoc/deleteById`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// 查找设备资料
export const selectDeviceinfoDoc = (params) => {
  return axios
    .post(`${base}/deviceDoc/selectDeviceinfoDoc`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 扫码显示设备资料
export const selectDeviceinfoDocScan = (params) => {
  return axios
    .post(`${base}/deviceDoc/selectDeviceinfoDocScan`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 修改设备资料
export const updateById = (params) => {
  return axios
    .post(`${base}/deviceDoc/updateById`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 固定资产卡片
export const assetCard = (params) => {
  return axios
    .post(`${base}/word/assetCard`, Qs.stringify(params), {
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// 查询需要设备科审核设备
export const selectByShenhe = (params) => {
  return axios
    .post(`${base}/deviceinfo/selectByShenhe`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 设备科审核
export const examine = (params) => {
  return axios
    .post(`${base}/deviceinfo/examine`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 获取项目名称
export const selectAllProjectName = (params) => {
  return axios
    .get(`${base}/projectinfo/selectAllProjectName`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 查找项目
export const selectAllProjectinfo = (params) => {
  return axios
    .post(`${base}/projectinfo/selectAllProjectinfo`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 查找试验室
export const getSys = (params) => {
  return axios
    .get(`${base}/company/getSys`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据试验室查找试验室
export const getSysByCompanyCode = (params) => {
  return axios
    .post(`${base}/company/getSysByCompanyCode`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 添加项目
export const insertProjectinfo = (params) => {
  return axios
    .post(`${base}/projectinfo/insertProjectinfo`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 修改项目
export const updateProjectinfo = (params) => {
  return axios
    .post(`${base}/projectinfo/updateProjectinfo`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 删除项目
export const deleteProjectinfo = (params) => {
  return axios
    .post(`${base}/projectinfo/deleteProjectinfo`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据deviceId查询检定信息
export const getByDeviceId = (params) => {
  return axios
    .get(`${base}/deviceCheck/selectByDeviceId`, {
      params: {
        deviceId: params.deviceId,
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据deviceId查询检定信息
export const deleteCheckId = (params) => {
  return axios
    .get(`${base}/deviceCheck/deleteCheck`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

// 仅删除检定记录，不回退检定日期
export const simpleDeleteCheckId = (id) => {
  return axios
    .get(`${base}/deviceCheck/simpleDeleteCheck`, { params: { id } })
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据deviceId查询维保信息
export const getMaintenanceByDeviceId = (params) => {
  return axios
    .get(`${base}/deviceMaintenance/getMaintenanceByDeviceId`, {
      params: {
        deviceId: params.deviceId,
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询检定预警信息
export const selectAllWarning = (params) => {
  return axios
    .get(`${base}/deviceCheck/findAllWarning`, {
      params: {
        content: params.content,
        start: params.start,
        end: params.end,
        pageIndex: params.pageIndex,
        companyCode: params.companyCode,
        pageSize: params.pageSize,
        jdlx: params.jdlx,
        jjts: params.jjts,
        userId: params.userId,
        deviceType: params.deviceType,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//检定上传检定附件
export const uploadFlie = (params) => {
  return axios
    .post(`${base}/deviceCheck/upload`, params, {
      "Content-Type": "multipart/form-data;charset=utf-8",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id查找检定附件信息信息
export const findByidFile = (params) => {
  return axios
    .get(`${base}/deviceCheck/findByIdDeviceCheckEnclosure`, {
      params: { id: params },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//检定录入
export const insertCheck = (params) => {
  return axios
    .post(`${base}/deviceCheck/addDeviceCheck`, params)
    .then((res) => res.data)
    .catch((error) => error);
};
//删除检定附件
export const delCheckFile = (params) => {
  return axios
    .get(`${base}/deviceCheck/delDeviceCheckEnclosure`, {
      params: { id: params },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询所有检定信息
export const selectAllCheck = (params) => {
  return axios
    .get(`${base}/deviceCheck/findAllDeviceCheck`, {
      params: {
        content: params.content,
        start: params.start,
        end: params.end,
        state: params.state,
        jdlx: params.jdlx,
        userId: params.userId,
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
        companyCode: params.companyCode,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询id查询检定信息
export const selectByIdCheck = (params) => {
  return axios
    .get(`${base}/deviceCheck/findByIdDeviceCheck`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询id修改检定信息
export const updateDeviceCheck = (params) => {
  return axios
    .post(`${base}/deviceCheck/updateDeviceCheck`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id删除检定信息
export const delByIdCheck = (params) => {
  return axios
    .get(`${base}/deviceCheck/delCheck`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id确认检定信息
export const confirmByIdCheck = (params) => {
  return axios
    .post(`${base}/deviceCheck/confirmDeviceCheck`, params)
    .then((res) => res.data)
    .catch((error) => error);
};
//检定校准批量确认
export const confirmCheckBatch = (params) => {
  return axios
    .post(`${base}/deviceCheck/confirmDeviceCheckBatch`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//查找所有维保信息
export const selectAllMaintenance = (params) => {
  return axios
    .get(`${base}/deviceMaintenance/findAllDeviceMaintenance`, {
      params: {
        content: params.content,
        start: params.start,
        end: params.end,
        state: params.state,
        userId: params.userId,
        companyCode: params.companyCode,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找所有维保信息
export const findLRDeviceMaintenance = (params) => {
  return axios
    .get(`${base}/deviceMaintenance/findLRDeviceMaintenance`, {
      params: {
        content: params.content,
        start: params.start,
        end: params.end,
        userId: params.userId,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id查找维保信息
export const findByIdMaintenance = (params) => {
  return axios
    .get(`${base}/deviceMaintenance/findByIdMaintenance`, {
      params: { id: params.id },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//判断是否具有审批权限
export const cxqx = (params) => {
  return axios
    .get(`${base}/deviceMaintenance/cxqx`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//判断是否具有确认权限
export const cxqrqx = (params) => {
  return axios
    .get(`${base}/deviceMaintenance/cxqrqx`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//判断是否具有录入权限
export const cxlrqx = (params) => {
  return axios
    .get(`${base}/deviceMaintenance/cxlrqx`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找所有维保审批信息
export const approveByIdMaintenance = (params) => {
  return axios
    .get(`${base}/deviceMaintenance/approveByIdMaintenance`, {
      params: {
        content: params.content,
        start: params.start,
        end: params.end,
        state: params.state,
        userId: params.userId,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找添加维保信息
export const addMaintenance = (params) => {
  return axios
    .post(`${base}/deviceMaintenance/addDeviceMaintenance`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//批量添加维保信息
export const addDeviceMaintenances = (params) => {
  return axios
    .post(`${base}/deviceMaintenance/addDeviceMaintenances`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id更新维保信息
export const updateMaintenance = (params) => {
  return axios
    .post(`${base}/deviceMaintenance/updateDeviceMaintenance`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id删除维保信息
export const delByIdDeviceMaintenance = (params) => {
  return axios
    .get(`${base}/deviceMaintenance/delByIdDeviceMaintenance`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id撤回维保信息
export const withdrawDeviceMaintenance = (params) => {
  return axios
    .get(`${base}/deviceMaintenance/withdrawDeviceMaintenance`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//上传附件信息
export const upload = (params) => {
  return axios
    .post(`${base}/upload/enclosure`, params, {
      "Content-Type": "multipart/form-data;charset=utf-8",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// 上传图片
export const uploadImage = (params) => {
  return axios
    .post(`${base}/upload/image`, params, {
      "Content-Type": "multipart/form-data;charset=utf-8",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// 上传APK
export const uploadApk = (params) => {
  return axios
    .post(`${base}/upload/apk`, params, {
      "Content-Type": "multipart/form-data;charset=utf-8",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//批量录入
export const importLr = (params) => {
  return axios
    .post(`${base}/word/importLr`, params, {
      "Content-Type": "multipart/form-data;charset=utf-8",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id 查找附件信息
export const findByIdFile = (params) => {
  return axios
    .get(`${base}/upload/findById`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id 删除附件信息
export const delByIdFile = (params) => {
  return axios
    .get(`${base}/upload/delByIdFile`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id查找业务流程信息
export const findByIdWorkflow = (params) => {
  return axios
    .get(`${base}/workflow/findAllWorkflowInformation`, {
      params: { id: params },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//维保业务审核
export const auditMaintenance = (params) => {
  return axios
    .post(`${base}/deviceMaintenance/auditMaintenance`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//录入维保信息
export const inputMaintenance = (params) => {
  return axios
    .post(`${base}/deviceMaintenance/inputMaintenance`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//确认维保信息
export const notarizeMaintenance = (params) => {
  return axios
    .post(`${base}/deviceMaintenance/notarizeMaintenance`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};

//查找报废信息
export const findAllDeviceScrap = (params) => {
  return axios
    .get(`${base}/deviceScrap/findAllDeviceScrap`, {
      params: {
        content: params.content,
        start: params.start,
        end: params.end,
        state: params.state,
        userId: params.userId,
        companyCode: params.companyCode,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//添加报废信息
export const addDeviceScrap = (params) => {
  return axios
    .post(`${base}/deviceScrap/addDeviceScrap`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//批量添加报废信息
export const addDeviceScraps = (params) => {
  return axios
    .post(`${base}/deviceScrap/addDeviceScraps`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id删除报废信息
export const delDeviceScrap = (params) => {
  return axios
    .get(`${base}/deviceScrap/delDeviceScrap`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id撤回报废申请
export const withdrawDeviceScrap = (params) => {
  return axios
    .get(`${base}/deviceScrap/withdrawDeviceScrap`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//根据id修改报废信息
export const updDeviceScrap = (params) => {
  return axios
    .post(`${base}/deviceScrap/updDeviceScrap`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//查找是否具有审批权限
export const cxbfspqx = (params) => {
  return axios
    .get(`${base}/deviceScrap/cxbfspqx`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找是否具有确认权限
export const cxbfqrqx = (params) => {
  return axios
    .get(`${base}/deviceScrap/cxbfqrqx`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id查找审批信息
export const approveByIdScrap = (params) => {
  return axios
    .get(`${base}/deviceScrap/approveByIdScrap`, {
      params: {
        content: params.content,
        start: params.start,
        end: params.end,
        state: params.state,
        userId: params.userId,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//审核报废信息
export const auditScrap = (params) => {
  return axios
    .post(`${base}/deviceScrap/auditScrap`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//确认报废信息
export const notarizeScrap = (params) => {
  return axios
    .post(`${base}/deviceScrap/notarizeScrap`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id查找报废信息
export const findByIdScrap = (params) => {
  return axios
    .get(`${base}/deviceScrap/findByIdScrap`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};

//查找调拨信息
export const findAllAllocation = (params) => {
  return axios
    .get(`${base}/Allocation/findAllAllocation`, {
      params: {
        content: params.content,
        start: params.start,
        end: params.end,
        state: params.state,
        dblx: params.dblx,
        transferIn: params.transferIn,
        transferOut: params.transferOut,
        userId: params.userId,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找审批调拨信息
export const findTransferAllocation = (params) => {
  return axios
    .get(`${base}/Allocation/findTransferAllocation`, {
      params: {
        content: params.content,
        start: params.start,
        end: params.end,
        state: params.state,
        dblx: params.dblx,
        transferIn: params.transferIn,
        transferOut: params.transferOut,
        userId: params.userId,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找调拨确认信息
export const findOutAllocation = (params) => {
  return axios
    .get(`${base}/Allocation/findOutAllocation`, {
      params: {
        content: params.content,
        start: params.start,
        end: params.end,
        state: params.state,
        dblx: params.dblx,
        transferIn: params.transferIn,
        transferOut: params.transferOut,
        userId: params.userId,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//根据deviceId查找调拨信息
export const selectAllactionByDeviceId = (params) => {
  return axios
    .get(`${base}/Allocation/selectByDeviceId`, {
      params: {
        deviceId: params.deviceId,
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//确认完成调拨
export const submitBatchId = (params) => {
  return axios
    .get(`${base}/Allocation/submitBatchId`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// 添加调拨信息
export const addAllocation = (params) => {
  return axios
    .post(`${base}/Allocation/addAllocation`, JSON.stringify(params), {
      headers: { "Content-Type": "application/json;charsetset=UTF-8" },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//更改调拨信息
export const updateAllocation = (params) => {
  return axios
    .post(`${base}/Allocation/updateAllocation`, JSON.stringify(params), {
      headers: { "Content-Type": "application/json;charsetset=UTF-8" },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

// 根据id查找调拨信息
export const findByIdAllocation = (params) => {
  return axios
    .get(`${base}/Allocation/findByIdAllocation`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据id查找父调拨单号下的所有调拨设备
export const selectAllDevice = (params) => {
  return axios
    .get(`${base}/Allocation/selectAllDevice`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

// 根据id查找调拨信息
export const selectByPid = (params) => {
  return axios
    .get(`${base}/Allocation/selectByPid`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id查找调拨设备
export const findByIdDevice = (params) => {
  return axios
    .get(`${base}/Allocation/findByIdDevice`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id删除调拨设备
export const delByIdDevice = (params) => {
  return axios
    .get(`${base}/Allocation/delByIdDevice`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id撤回设备调拨
export const withdrawAllocation = (params) => {
  return axios
    .get(`${base}/Allocation/withdrawAllocation`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//调拨申请撤回
export const applyWithdraw = (params) => {
  return axios
    .get(`${base}/Allocation/applyWithdraw`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id查询申请调入设备信息
export const findTransferIn = (params) => {
  return axios
    .get(`${base}/Allocation/findTransferIn`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//审批调拨
export const examineAllocation = (params) => {
  return axios
    .post(`${base}/Allocation/examineAllocation`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);

  // return axios.get(`${base}/Allocation/examineAllocation`,{params:{id:params.id,shyj:params.shyj,shjg:params.shjg,sout:params.sout}},).then(res => res.data).catch(error => error);
};
//
//调拨确认
export const confirmAllocation = (params) => {
  return axios
    .post(`${base}/Allocation/confirmAllocation`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//查找所有任务信息
export const findAllTask = (params) => {
  return axios
    .get(`${base}/task/findAllTask`, {
      params: {
        start: params.start,
        end: params.end,
        state: params.state,
        rwlx: params.rwlx,
        userId: params.userId,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//查找所有任务信息
export const findElevateTask = (params) => {
  return axios
    .get(`${base}/task/findElevateTask`, {
      params: {
        start: params.start,
        end: params.end,
        state: params.state,
        rwlx: params.rwlx,
        userId: params.userId,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找所有任务信息
export const findByZxr = (params) => {
  return axios
    .get(`${base}/task/findByZxr`, {
      params: {
        start: params.start,
        end: params.end,
        rwlx: params.rwlx,
        userId: params.userId,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//添加任务信息
export const addTask = (params) => {
  return axios
    .post(`${base}/task/addTask`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id查找任务信息
export const findByIdTask = (params) => {
  return axios
    .get(`${base}/task/findByIdTask`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据任务Id查找执行人情况
export const findByIdZx = (params) => {
  return axios
    .get(`${base}/task/findByIdZx`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id查找任务设备信息
export const findByIdTaskDevice = (params) => {
  return axios
    .get(`${base}/task/findByIdTaskDevice`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id编辑任务信息
export const updTask = (params) => {
  return axios
    .post(`${base}/task/updTask`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据id删除任务信息
export const delTask = (params) => {
  // return axios.get(`${base}/task/delTask`,{params:{id:params}}).then(res => res.data).catch(error => error);
  return axios
    .post(`${base}/task/delTask`, JSON.stringify(params), {
      headers: { "Content-Type": "application/json;charsetset=UTF-8" },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//执行任务
export const implementTask = (params) => {
  return axios
    .post(`${base}/task/implementTask`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//完成任务
export const completeTask = (params) => {
  return axios
    .get(`${base}/task/completeTask`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//任务评价
export const evaluateTask = (params) => {
  return axios
    .post(`${base}/task/evaluateTask`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//查找所有用户
export const findAllUser = (params) => {
  return axios
    .get(`${base}/user/findAllUser`, {
      params: { content: params.content, companyCode: params.companyCode },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找所有用户
export const findAllUserList = (params) => {
  return axios
    .get(`${base}/user/findAllUserList`, {
      params: { content: params.content, companyCode: params.companyCode },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//停用用户
export const delUser = (params) => {
  return axios
    .post(`${base}/user/delUser`, JSON.stringify(params), {
      headers: { "Content-Type": "application/json;charsetset=UTF-8" },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//启用用户
export const insetUser = (params) => {
  return axios
    .get(`${base}/user/insetUser`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//删除用户
export const userDel = (params) => {
  return axios
    .get(`${base}/user/userDel`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id查找用户
export const findByIdUser = (params) => {
  return axios
    .get(`${base}/user/findByIdUser`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
// 添加用户
export const addUser = (params) => {
  return axios
    .post(`${base}/user/addUser`, JSON.stringify(params), {
      headers: { "Content-Type": "application/json;charsetset=UTF-8" },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// 修改用户
export const updateUser = (params) => {
  return axios
    .post(`${base}/user/updateUser`, JSON.stringify(params), {
      headers: { "Content-Type": "application/json;charsetset=UTF-8" },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//查找所有部门
export const selectAllDepartment = (params) => {
  return axios
    .get(`${base}/department/selectAllDepartment`, {
      params: { content: params },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据机构code所有部门
export const selectByIdDepartment = (params) => {
  return axios
    .get(`${base}/department/selectByIdDepartment`, {
      params: { companyCode: params },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据code删除部门
export const delDepartment = (params) => {
  return axios
    .get(`${base}/department/delDepartment`, { params: { code: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//添加部门
export const addDepartment = (params) => {
  return axios
    .post(`${base}/department/addDepartment`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//修改部门
export const updateDepartment = (params) => {
  return axios
    .post(`${base}/department/updateDepartment`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
// 根据id修改密码
export const resettingPassword = (params) => {
  return axios
    .get(`${base}/user/resettingPassword`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};

//树结构查询单位
export const treeCompany = (params) => {
  return axios
    .get(`${base}/company/treeCompany`)
    .then((res) => res.data)
    .catch((error) => error);
};

//使用记录跳转配置-查询列表
export const listUsageJumpConfig = (params) => {
  return axios
    .get(`${base}/usageJumpConfig/list`)
    .then((res) => res.data)
    .catch((error) => error);
};
//使用记录跳转配置-保存
export const saveUsageJumpConfig = (params) => {
  return axios
    .post(`${base}/usageJumpConfig/save`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//使用记录跳转配置-删除
export const deleteUsageJumpConfig = (id) => {
  return axios
    .get(`${base}/usageJumpConfig/delete`, { params: { id } })
    .then((res) => res.data)
    .catch((error) => error);
};
//使用记录跳转配置-扫码页查询跳转地址
export const getUsageJumpUrl = (companyCode) => {
  return axios
    .get(`${base}/usageJumpConfig/getJumpUrl`, { params: { companyCode } })
    .then((res) => res.data)
    .catch((error) => error);
};
//添加单位
export const addCompany = (params) => {
  return axios
    .post(`${base}/company/addCompany`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//添加公司
export const addBigCompany = (params) => {
  return axios
    .post(`${base}/company/addBigCompany`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//修改单位
export const updCompany = (params) => {
  return axios
    .post(`${base}/company/updCompany`, params)
    .then((res) => res.data)
    .catch((error) => error);
};
//删除选中单位
export const delCompany = (params) => {
  return axios
    .get(`${base}/company/delCompany`, { params: { code: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据当前单位选中所有直系单位
export const getCompanyPCodeList = (params) => {
  return axios
    .get(`${base}/company/getCompanyPCodeList`, {
      params: { companyCode: params },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找所有分页
export const selectAllPage = (params) => {
  return axios
    .get(`${base}/role/selectAllPage`)
    .then((res) => res.data)
    .catch((error) => error);
};

//查找所有角色
export const selectAllRole = (params) => {
  return axios
    .get(`${base}/role/selectAllRole`)
    .then((res) => res.data)
    .catch((error) => error);
};
//添加角色
export const addRole = (params) => {
  return axios
    .post(`${base}/role/addRole`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//修改角色
export const updateRole = (params) => {
  return axios
    .post(`${base}/role/updateRole`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//通过id查找角色
export const findByIdRole = (params) => {
  return axios
    .get(`${base}/role/findByIdRole`, { params: { roleId: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//删除角色
export const delRole = (params) => {
  return axios
    .post(`${base}/role/delRole`, JSON.stringify(params), {
      headers: { "Content-Type": "application/json;charsetset=UTF-8" },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//设置角色权限
export const updRole = (params) => {
  return axios
    .post(`${base}/role/updRole`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};

//查找待办
export const myTranslate = (params) => {
  return axios
    .get(`${base}/translate/myTranslate`, { params: { userId: params.userId } })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找树状设备分类
export const selectTreeDeviceType = (params) => {
  return axios
    .get(`${base}/deviceType/selectTreeDeviceType`)
    .then((res) => res.data)
    .catch((error) => error);
};
//添加设备子类型
export const addDeviceType = (params) => {
  return axios
    .post(`${base}/deviceType/addDeviceType`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//添加大类
export const addBigType = (params) => {
  return axios
    .post(`${base}/deviceType/addBigType`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//更新设备信息
export const updateBigType = (params) => {
  return axios
    .post(`${base}/deviceType/updateBigType`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//删除选中设备类型
export const deleteDeviceType = (params) => {
  return axios
    .get(`${base}/deviceType/deleteDeviceType`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据查找维修人员
export const findByRoleUser = (params) => {
  return axios
    .get(`${base}/user/findByRoleUser`)
    .then((res) => res.data)
    .catch((error) => error);
};
//根据查找所有资料
export const findAllData = (params) => {
  return axios
    .get(`${base}/training/findAllData`, {
      params: {
        start: params.start,
        end: params.end,
        content: params.content,
        companyCode: params.companyCode,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据查找资料类型
export const findAllType = (params) => {
  return axios
    .get(`${base}/training/findAllType`)
    .then((res) => res.data)
    .catch((error) => error);
};
//添加培训资料
export const addFile = (params) => {
  return axios
    .post(`${base}/upload/addFile`, params, {
      "Content-Type": "multipart/form-data;charset=utf-8",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//更新资料信息
export const updateData = (params) => {
  return axios
    .post(`${base}/training/updateData`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//删除资料信息
export const deleteData = (params) => {
  return axios
    .get(`${base}/training/deleteData`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找审批流程
export const findAllWorkflow = (params) => {
  return axios
    .get(`${base}/workflow/findAllWorkflow`)
    .then((res) => res.data)
    .catch((error) => error);
};
//修改节点名称
export const updateNodeName = (params) => {
  return axios
    .get(`${base}/workflow/updateNodeName`, {
      params: { id: params.id, nodeName: params.nodeName },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id查找审批节点
export const findByIdNode = (params) => {
  return axios
    .get(`${base}/workflow/findByIdNode`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//更新节点信息
export const updateNode = (params) => {
  return axios
    .post(`${base}/workflow/updateNode`, JSON.stringify(params), {
      headers: { "Content-Type": "application/json;charsetset=UTF-8" },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据Node查询节点授权
export const findByNodeActivity = (params) => {
  return axios
    .get(`${base}/workflow/findByNodeActivity`, {
      params: { nodeId: params.nodeId, workflowId: params.workflowId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据Node插入节点授权
export const addNodeActivity = (params) => {
  // return axios.post(`${base}/workflow/addNodeActivity`,params).then(res => res.data).catch(error => error);
  return axios
    .post(`${base}/workflow/addNodeActivity`, JSON.stringify(params), {
      headers: { "Content-Type": "application/json;charsetset=UTF-8" },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//根据id查找审批节点
export const deleteNodeActivity = (params) => {
  return axios
    .get(`${base}/workflow/deleteNodeActivity`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询所有操作日志
export const findAllLog = (params) => {
  // return axios.get(`${base}/log/findAllLog`, { params: { start: params.start, end: params.end,content: params.content } }).then(res => res.data).catch(error => error);
  return axios
    .get(`${base}/log/findAllLog`, {
      params: {
        start: params.start,
        end: params.end,
        content: params.content,
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询所有采购信息
export const findAllPurchaseInformation = (params) => {
  return axios
    .get(`${base}/purchaseInformation/findAllPurchaseInformation`, {
      params: {
        start: params.start,
        end: params.end,
        status: params.status,
        content: params.content,
        userId: params.userId,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询所有采购信息
export const findByIdPurchaseInformation = (params) => {
  return axios
    .get(`${base}/purchaseInformation/findByIdPurchaseInformation`, {
      params: { id: params.id },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//添加采购计划
export const addPurchaseInformation = (params) => {
  return axios
    .post(`${base}/purchaseInformation/addPurchaseInformation`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//采购计划提交
export const submitPurchaseInformation = (params) => {
  return axios
    .post(`${base}/purchaseInformation/submitPurchaseInformation`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//采购计划审核
export const examinePurchaseInformation = (params) => {
  return axios
    .post(`${base}/purchaseInformation/examinePurchaseInformation`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//采购计划审核
export const deletePurchaseInformation = (params) => {
  return axios
    .get(`${base}/purchaseInformation/deletePurchaseInformation`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找所有采购合同
export const findAllPurchaseContract = (params) => {
  return axios
    .get(`${base}/purchaseContract/findAllPurchaseContract`, {
      params: { company: params.company, signUser: params.signUser },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//上传采购合同
export const contractUpload = (params) => {
  return axios
    .post(`${base}/purchaseContract/upload`, params, {
      "Content-Type": "multipart/form-data;charset=utf-8",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//作废采购合同
export const delPurchaseContract = (params) => {
  return axios
    .get(`${base}/purchaseContract/delPurchaseContract`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找所有采购设备验收
export const findAllPurchaseCheck = (params) => {
  return axios
    .get(`${base}/purchaseInformation/findAllPurchaseCheck`, {
      params: { statue: params.statue, content: params.content },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//添加采购设备验收
export const addPurchaseCheck = (params) => {
  return axios
    .post(`${base}/purchaseInformation/addPurchaseCheck`, params, {
      "Content-Type": "multipart/form-data;charset=utf-8",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//采购设备验收修改
export const updatePurchaseCheck = (params) => {
  return axios
    .post(`${base}/purchaseInformation/updatePurchaseCheck`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//采购设备验收删除
export const deletePurchaseCheck = (params) => {
  return axios
    .get(`${base}/purchaseInformation/deletePurchaseCheck`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询所有待验收单号
export const findAllCheckId = (params) => {
  return axios
    .get(`${base}/purchaseInformation/findAllCheckId`, {
      params: { userId: params },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询所有供应商评价
export const findAllPurchaseEvaluate = (params) => {
  return axios
    .get(
      `${base}/purchaseContract/findAllPurchaseEvaluate`,
      Qs.stringify(params)
    )
    .then((res) => res.data)
    .catch((error) => error);
};
//添加供应商评价
export const addPurchaseEvaluate = (params) => {
  return axios
    .post(`${base}/purchaseContract/addPurchaseEvaluate`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//修改供应商评价
export const updatePurchaseEvaluate = (params) => {
  return axios
    .post(`${base}/purchaseContract/updatePurchaseEvaluate`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//删除供应商评价
export const deletePurchaseEvaluate = (params) => {
  return axios
    .get(`${base}/purchaseContract/deletePurchaseEvaluate`, {
      params: { id: params.id, userId: params.userId },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找所有合作公司
export const findAllCorporation = (params) => {
  return axios
    .get(`${base}/purchaseContract/findAllCorporation`)
    .then((res) => res.data)
    .catch((error) => error);
};
// 文件下载upload/media
export const download = (params) => {
  // 请求头
  return axios
    .post(`${base}/upload/media`, Qs.stringify(params), {
      // headers: {
      //     'Content-Type': 'Access-Control-Allow-Origin'
      //   },
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//维保统计
export const selectMaintenanceUser = (params) => {
  return axios
    .get(
      `${base}/deviceMaintenance/selectMaintenanceUser`,
      Qs.stringify(params)
    )
    .then((res) => res.data)
    .catch((error) => error);
};
//根据维修人员id查找维保单号
export const selectMaintenanceUserById = (params) => {
  return axios
    .get(`${base}/deviceMaintenance/selectMaintenanceUserById`, {
      params: { id: params.id },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找使用人员变更记录
export const selectAllPersonal = (params) => {
  return axios
    .get(`${base}/personal/selectAllPersonal`, {
      params: {
        start: params.start,
        end: params.end,
        content: params.content,
        type: params.type,
        userId: params.userId,
        companyCode: params.companyCode,
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//添加人员变更记录
export const insertPersonal = (params) => {
  return axios
    .post(`${base}/personal/insertPersonal`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//删除人员变更记录
export const deletePersonal = (params) => {
  return axios
    .get(`${base}/personal/deletePersonal`, { params: { id: params.id } })
    .then((res) => res.data)
    .catch((error) => error);
};
//修改人员变更记录
export const updatePersonal = (params) => {
  return axios
    .post(`${base}/personal/updatePersonal`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//批量下载检定附件
export const test = (params) => {
  return axios
    .post(`${base}/upload/test`, Qs.stringify(params), {
      // headers: {
      //     'Content-Type': 'Access-Control-Allow-Origin'
      //   },
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
// //批量测试
// export const wordTest = params => {
//
//     return axios.post(`${base}/word/task`, params,{
//         // headers: {
//         //     'Content-Type': 'Access-Control-Allow-Origin'
//         //   },
//         responseType: 'blob'
//     }
//    ).then(res => res.data).catch(error => error);
// };
//批量下载维保计划
export const wbjh = (params) => {
  return axios
    .post(`${base}/word/test`, Qs.stringify(params), {
      // headers: {
      //     'Content-Type': 'Access-Control-Allow-Origin'
      //   },
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//导出检定台账
export const derivation = (params) => {
  return axios
    .post(`${base}/word/derivation`, Qs.stringify(params), {
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//导出检定台账
export const wordAllExport = (params) => {
  return axios
    .post(`${base}/word/wordAllExport`, Qs.stringify(params), {
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//导出报废申请表台账
export const BFWord = (params) => {
  return axios
    .get(`${base}/word/BFWord`, {
      // headers: {
      //     'Content-Type': 'Access-Control-Allow-Origin'
      //   },
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//导出维保台账
export const excelWBExport = (params) => {
  return axios
    .post(`${base}/word/excelWBExport`, Qs.stringify(params), {
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//导出报废台账
export const excelBFExport = (params) => {
  return axios
    .post(`${base}/word/excelBFExport`, Qs.stringify(params), {
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//查找项目
export const selectByIdProject = (params) => {
  return axios
    .get(`${base}/project/selectByIdProject`, { params: { id: params } })
    .then((res) => res.data)
    .catch((error) => error);
};
//查找查找项目设备
export const selectByIdDevice = (params) => {
  return axios
    .get(`${base}/project/selectByIdDevice`, {
      params: { id: params.id, mid: params.mid },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//项目设备维护
export const addProjectDevice = (params) => {
  return axios
    .get(`${base}/project/addProjectDevice`, {
      params: { id: params.id, mid: params.mid, name: params.name },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//项目设备删除
export const deleteProjectDevice = (params) => {
  return axios
    .get(`${base}/project/deleteProjectDevice`, {
      params: { id: params.id, mid: params.mid, name: params.name },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//删除项目
export const deleteProject = (params) => {
  return axios
    .get(`${base}/project/deleteProject`, {
      params: { mid: params.mid, name: params.name },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//添加项目
export const addProject = (params) => {
  return axios
    .get(`${base}/project/addProject`, {
      params: { mid: params.mid, name: params.name },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//添加项目
export const updateProject = (params) => {
  return axios
    .get(`${base}/project/updateProject`, {
      params: { id: params.id, mid: params.mid, name: params.name },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//修改附件
export const updateCheckEnclosure = (params) => {
  return axios
    .post(`${base}/deviceCheck/updateCheckEnclosure`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//获取账户列表
export const selectTenant = (params) => {
  return axios
    .post(`${base}/tenants/selectAll`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//新增账户
export const addTenant = (params) => {
  return axios
    .post(`${base}/tenants/addTenant`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//修改账户
export const updateTenant = (params) => {
  return axios
    .post(`${base}/tenants/updateTenant`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};

//划入设备超市
export const transferToMarket = (params) => {
  return axios
    .post(`${base}/deviceinfo/transferToMarket`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//划出设备超市
export const transferOutMarket = (params) => {
  return axios
    .post(`${base}/deviceinfo/transferOutMarket`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查询所有设备台账-设备超市
export const selectAllDeviceinfoInMarket = (params) => {
  return axios
    .post(`${base}/market/selectAllDeviceinfo`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};

//地址选择
export const selectArea = (params) => {
  return axios
    .post(`${base}/area/select`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//获取设备借用记录
export const mktBorrowSelect = (params) => {
  const { pageIndex, pageSize, ...rest } = params;
  const query = `pageIndex=${pageIndex || 1}&pageSize=${pageSize || 10}`;
  return axios
    .post(`${base}/mktBorrow/select?${query}`, rest)
    .then((res) => res.data)
    .catch((error) => error);
};
//获取设备借用确认记录
export const mktBorrowSelectConfirm = (params) => {
  const { pageIndex, pageSize, ...rest } = params;
  const query = `pageIndex=${pageIndex || 1}&pageSize=${pageSize || 10}`;
  return axios({
    method: "post",
    url: `${base}/mktBorrow/selectConfirm?${query}`,
    data: Qs.stringify(rest),
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res) => res.data)
    .catch((error) => error);
};
//保存设备借用记录
export const mktBorrowAdd = (params) => {
  return axios
    .post(`${base}/mktBorrow/add`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查看详细借用记录
export const mktBorrowView = (params) => {
  return axios
    .get(`${base}/mktBorrow/view?id=` + params)
    .then((res) => res.data)
    .catch((error) => error);
};

//领用确认查看
export const mktBorrowConfirmView = (params) => {
  return axios
    .get(`${base}/mktBorrow/viewConfirm?id=` + params)
    .then((res) => res.data)
    .catch((error) => error);
};

//查看借用的设备详细
export const mktBorrowViewDetail = (params) => {
  return axios
    .get(`${base}/mktBorrow/viewDetail?detailId=` + params)
    .then((res) => res.data)
    .catch((error) => error);
};

//通过设备id查询借用记录
export const mktBorrowSelectDetailByDeviceId = (params) => {
  return axios
    .get(`${base}/mktBorrow/selectDetailByDeviceId`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};

//删除借用记录
export const mktBorrowDelete = (params) => {
  return axios
    .get(`${base}/mktBorrow/delete`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};

//提交草稿（草稿→待审核 + 锁定设备）
export const mktBorrowSubmit = (params) => {
  return axios
    .post(`${base}/mktBorrow/submit`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//撤回申请（待审核→草稿 + 释放设备）
export const mktBorrowCancel = (params) => {
  return axios
    .get(`${base}/mktBorrow/cancel`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};

//编辑草稿
export const mktBorrowUpdateDraft = (params) => {
  return axios
    .post(`${base}/mktBorrow/updateDraft`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//删除草稿
export const mktBorrowDeleteDraft = (params) => {
  return axios
    .get(`${base}/mktBorrow/deleteDraft`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};
//修改借用状态
export const updateStatus = (params) => {
  return axios
    .get(`${base}/mktBorrow/updateStatus`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};
//审核借用记录
export const mktBorrowAudit = (params) => {
  return axios
    .post(`${base}/mktBorrow/audit`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//货架选择
export const selectShelves = (params) => {
  return axios
    .post(`${base}/shelves/select`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};
//保存货架变更
export const shelvesChangeAdd = (params) => {
  return axios
    .post(`${base}/shelvesChange/add`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//项目列表
export const mktProjectList = (params) => {
  return axios
    .get(`${base}/mktProject/select`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};
//未结束的项目列表
export const mktProjectUnfinishedList = (params) => {
  return axios
    .get(`${base}/mktProject/selectUnfinished`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};
//增加项目
export const mktProjectAdd = (params) => {
  return axios
    .post(`${base}/mktProject/add`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//查看项目
export const mktProjectView = (params) => {
  return axios
    .get(`${base}/mktProject/view`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};

//调换设备
export const mktExchange = (params) => {
  return axios
    .post(`${base}/mktBorrow/exchange`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//导出设备超市台账
export const exportMarketDevice = (params) => {
  return axios
    .post(`${base}/market/exportDevice`, Qs.stringify(params), {
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};
//导出设备借用台账
export const exportMarketRecord = (params) => {
  return axios
    .post(`${base}/market/exportRecord`, Qs.stringify(params), {
      responseType: "blob",
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//导入设备借用台账
export const importMarketRecord = (params) => {
  return axios
    .post(`${base}/market/importRecord`, params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//获取货架的树形结构
export const mktShelvesTree = (params) => {
  return axios
    .get(`${base}/shelves/getTree`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};

//增加货位
export const mktShelvesAdd = (params) => {
  return axios
    .post(`${base}/shelves/add`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//修改货位
export const mktShelvesEdit = (params) => {
  return axios
    .post(`${base}/shelves/edit`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

//删除货位
export const mktShelvesRemove = (params) => {
  return axios
    .get(`${base}/shelves/remove`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};


//设备出入库
export const mktSetDevice = (params) => {
  return axios
    .post(`${base}/mktBorrow/setDeviceWeb`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

// App版本管理 - 获取版本列表
export const getAppVersionList = (params) => {
  return axios
    .get(`${base}/appVersion/list`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};

// App版本管理 - 添加版本
export const addAppVersion = (params) => {
  return axios
    .post(`${base}/appVersion/add`, params)
    .then((res) => res.data)
    .catch((error) => error);
};

// App版本管理 - 更新版本
export const updateAppVersion = (params) => {
  return axios
    .post(`${base}/appVersion/update`, params)
    .then((res) => res.data)
    .catch((error) => error);
};

// App版本管理 - 删除版本
export const deleteAppVersion = (id) => {
  return axios
    .post(`${base}/appVersion/delete/${id}`)
    .then((res) => res.data)
    .catch((error) => error);
};

// App版本管理 - 获取最新版本
export const getLatestAppVersion = (appType) => {
  return axios
    .get(`${base}/appVersion/getLatest`, { params: { appType } })
    .then((res) => res.data)
    .catch((error) => error);
};

// App版本管理 - 检查更新
export const checkAppUpdate = (appType, versionCode) => {
  return axios
    .get(`${base}/appVersion/checkUpdate`, { params: { appType, versionCode } })
    .then((res) => res.data)
    .catch((error) => error);
};

// ==================== 设备使用记录 ====================
// 查询使用记录列表
export const mktUsageRecordList = (params) => {
  return axios
    .get(`${base}/mktUsageRecord/list`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};

// 根据借用记录ID查询使用记录
export const mktUsageRecordListByBorrowId = (params) => {
  return axios
    .get(`${base}/mktUsageRecord/listByBorrowId`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};

// 根据设备ID查询使用记录
export const mktUsageRecordListByDeviceId = (deviceId) => {
  return axios
    .get(`${base}/mktUsageRecord/listByDeviceId`, { params: { deviceId } })
    .then((res) => res.data)
    .catch((error) => error);
};

// 新增使用记录
export const mktUsageRecordAdd = (params) => {
  return axios
    .post(`${base}/mktUsageRecord/add`, params)
    .then((res) => res.data)
    .catch((error) => error);
};

// 修改使用记录
export const mktUsageRecordUpdate = (params) => {
  return axios
    .post(`${base}/mktUsageRecord/update`, params)
    .then((res) => res.data)
    .catch((error) => error);
};

// 删除使用记录
export const mktUsageRecordDelete = (id) => {
  return axios
    .get(`${base}/mktUsageRecord/delete`, { params: { id } })
    .then((res) => res.data)
    .catch((error) => error);
};

// 导出使用记录
export const mktUsageRecordExport = (params) => {
  return axios
    .get(`${base}/mktUsageRecord/export`, { params, responseType: 'blob' })
    .then((res) => res)
    .catch((error) => error);
};


// ==================== 设备维护记录 ====================
// 查询维护记录列表
export const mktMaintenanceRecordList = (params) => {
  const { pageIndex, pageSize, ...rest } = params;
  const query = `pageIndex=${pageIndex || 1}&pageSize=${pageSize || 10}`;
  return axios
    .post(`${base}/mktMaintenanceRecord/select?${query}`, rest)
    .then((res) => res.data)
    .catch((error) => error);
};

// 新增维护记录
export const mktMaintenanceRecordAdd = (params) => {
  return axios
    .post(`${base}/mktMaintenanceRecord/add`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

// 修改维护记录
export const mktMaintenanceRecordUpdate = (params) => {
  return axios
    .post(`${base}/mktMaintenanceRecord/update`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => error);
};

// 删除维护记录
export const mktMaintenanceRecordDelete = (id) => {
  return axios
    .get(`${base}/mktMaintenanceRecord/delete`, { params: { id } })
    .then((res) => res.data)
    .catch((error) => error);
};

// 查看维护记录详情
export const mktMaintenanceRecordView = (id) => {
  return axios
    .get(`${base}/mktMaintenanceRecord/view`, { params: { id } })
    .then((res) => res.data)
    .catch((error) => error);
};

// 根据借用记录ID查询维护记录
export const mktMaintenanceRecordListByBorrowId = (params) => {
  return axios
    .get(`${base}/mktMaintenanceRecord/listByBorrowId`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};

// 根据设备ID查询维护记录
export const mktMaintenanceRecordListByDeviceId = (borrowId, deviceId, pageIndex, pageSize) => {
  return axios
    .get(`${base}/mktMaintenanceRecord/listByDeviceId`, {
      params: { borrowId, deviceId, pageIndex: pageIndex || 1, pageSize: pageSize || 10 }
    })
    .then((res) => res.data)
    .catch((error) => error);
};

// 导出维护记录
export const mktMaintenanceRecordExport = (params) => {
  return axios
    .get(`${base}/mktMaintenanceRecord/export`, { params, responseType: 'blob' })
    .then((res) => res)
    .catch((error) => error);
};

// 模拟登录（管理员切换到其他用户）
export const impersonate = (userId) => {
  return axios
    .post(`${base}/user/impersonate`, Qs.stringify({ userId }))
    .then((res) => res.data)
    .catch((error) => error);
};

// 退出模拟登录（恢复管理员身份）
export const revertImpersonate = () => {
  return axios
    .post(`${base}/user/revertImpersonate`)
    .then((res) => res.data)
    .catch((error) => error);
};

// 变更项目所属部门
export const changeDeviceProject = (params) => {
  return axios
    .post(`${base}/deviceDeptChangeRecord/changeDeviceProject`, Qs.stringify(params))
    .then((res) => res.data)
    .catch((error) => error);
};

// 查询指定设备的部门变更历史
export const getDeviceDeptChangeHistory = (params) => {
  return axios
    .get(`${base}/deviceDeptChangeRecord/history`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};

// 设备部门变更记录分页查询
export const getDeviceDeptChangeHistoryList = (params) => {
  return axios
    .get(`${base}/deviceDeptChangeRecord/list`, { params })
    .then((res) => res.data)
    .catch((error) => error);
};



// WEBPACK FOOTER //
// ./src/api/api.js